import { Tooltip } from 'app/modules/reports/components/tooltip'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React from 'react'

export function IconInteresting({ className, content }: { className?: string; content?: string }) {
  const { _t } = useTypedTranslation()

  return (
    <Tooltip content={content ?? _t('interesting')} placement="top">
      <i className={`ds3-icon ds3-warning-circle color-primary ${className}`}></i>
    </Tooltip>
  )
}
